import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import createTemplate from './modules/admin/templates/createTemplate';
import viewTemplate from './modules/admin/templates/viewTemplate';
import createEditUser from './modules/admin/users/createEditUser';
import viewUser from './modules/admin/users/viewUser';
import editGeneCombination from './modules/admin/templates/editGeneCombination';
import editTemplateCategory from './modules/admin/templates/editTemplateCategory';
import viewTemplateCategory from './modules/admin/templates/viewTemplateCategory';
import viewGeneCombination from './modules/admin/templates/viewGeneCombination';
import editRole from './modules/admin/roles/editRole';
import viewRole from './modules/admin/roles/viewRole';
import userDetail from './modules/admin/userDetail';
import viewResultDetail from './modules/admin/results/viewResultDetail';
import sampleDetail from './modules/admin/samples/sampleDetail';
import editSample from './modules/admin/samples/editSample';
import viewCustomer from './modules/admin/customers/viewDetailCustomer';
import resultCustomerDetail from './modules/admin/results/viewCustomerResult';
import editCustomer from './modules/admin/customers/editCustomer';
import createCustomer from './modules/admin/customers/createCustomer';
import createProductType from './modules/admin/producttypes/createProductType';
import editProductType from './modules/admin/producttypes/editProductType';
import productTypeDetail from './modules/admin/producttypes/productTypeDetail';
import dataTableFilters from './modules/admin/dataTableFilters';
import createConsultingRoom from './modules/admin/reservations/createConsultingRoom';
import consultingRoomDetail from './modules/admin/reservations/consultingRoomDetail';
import editConsultingRoom from './modules/admin/reservations/editConsultingRoom';
import editProduct from './modules/admin/products/editProduct';
import createMoneyVoucher from './modules/admin/vouchers/createMoneyVoucher';
import viewMoneyVoucher from './modules/admin/vouchers/viewMoneyVoucher';
import editMoneyVoucher from './modules/admin/vouchers/editMoneyVoucher';
import createProductVoucher from './modules/admin/vouchers/createProductVoucher';
import editProductVoucher from './modules/admin/vouchers/editProductVoucher';
import viewProductVoucher from './modules/admin/vouchers/viewProductVoucher';
import orderViewDetail from './modules/admin/orders/orderViewDetail';
import editCustomerRelationship from './modules/admin/customers/editCustomerRelationship';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    locale: 'en'
  },
  modules: {
    auth,
    createTemplate,
    viewTemplate,
    createEditUser,
    viewUser,
    editGeneCombination,
    editTemplateCategory,
    viewTemplateCategory,
    viewGeneCombination,
    editRole,
    viewRole,
    userDetail,
    viewResultDetail,
    sampleDetail,
    editSample,
    viewCustomer,
    resultCustomerDetail,
    editCustomer,
    createCustomer,
    createProductType,
    editProductType,
    productTypeDetail,
    dataTableFilters,
    createConsultingRoom,
    consultingRoomDetail,
    editConsultingRoom,
    editProduct,
    createMoneyVoucher,
    viewMoneyVoucher,
    editMoneyVoucher,
    createProductVoucher,
    editProductVoucher,
    viewProductVoucher,
    orderViewDetail,
    editCustomerRelationship
  }
});

Vue.store = store;

export default store;
